import { StrictMode } from "react";
import "./public-links.css";
import { createRoot } from "react-dom/client";
import EditorialApp from "./EditorialApp";
import "./styles.css";
import "./programme.css";
import "./programme-overrides.css";
import "./editorial-v2.css";
import "./editorial-v2-visuals.css";
import "./simple-repository.css";
import "./editorial/publication-structure.css";
import "./editorial/plain-language.css";

createRoot(document.getElementById("root")!).render(<StrictMode><EditorialApp /></StrictMode>);
